module.exports = __webpack_public_path__ + "media/images/auth/login-bg-7593b671c1b31531723137381c66ebfd.jpg";